import script from "./custom-attribute-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./custom-attribute-icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__